import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { ICompanyData } from '../../initialState';

export interface ICompanyCreateRequestAction {
  data: {
    VAT: string;
    companyName: string;
    email: string;
    firstName: string;
    gsm: string;
    iban: string;
    headQuarters: {
      city: string;
      number: number;
      street: string;
      zip: number;
    };
    language: string[];
    lastName: string;
    locale: string;
    website?: string;
  };
  functions: {
    error: (err: any) => void;
    goBack: () => void;
  };
}

function createRequest(
  draft: Draft<ICompanyData>,
  _: PayloadAction<ICompanyCreateRequestAction>,
) {
  draft.create.config.isLoading = true;
}

export default createRequest;
